import React, { Component } from "react";
import ToastList from "../components/ToastList";

const ToastContext = React.createContext();

export class ToastProvider extends Component {
  state = { toasts: [] };

  count = 0;

  clone = arr => {
    return arr.slice(0);
  };

  add = (status, headerText, bodyText) => {
    this.setState(state => {
      const id = this.count++;
      const toasts = this.clone(state.toasts);
      toasts.push({ status, headerText, bodyText, id });
      setTimeout(() => this.remove(id), 10000);
      return { toasts };
    });
  };

  remove = id => {
    this.setState(state => {
      const toasts = state.toasts.filter(t => t.id !== id);
      return { toasts };
    });
  };

  render() {
    const context = {
      add: this.add,
      remove: this.remove
    };

    return (
      <ToastContext.Provider value={context}>
        {this.props.children}
        <ToastList
          toasts={this.state.toasts}
          onRemove={toastId => this.remove(toastId)}
        />
      </ToastContext.Provider>
    );
  }
}

export default ToastContext;
